import { render, staticRenderFns } from "./RemoteHistory.vue?vue&type=template&id=758364ab&scoped=true"
import script from "./RemoteHistory.vue?vue&type=script&lang=js"
export * from "./RemoteHistory.vue?vue&type=script&lang=js"
import style0 from "./RemoteHistory.vue?vue&type=style&index=0&id=758364ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758364ab",
  null
  
)

export default component.exports